import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap-modal'

function SortingForm({initialSorting, sortingsToExclude, onClose, onSubmit}) {
  const initialSortings = {
    name:            { asc: 'A &#8594 Z', desc: 'Z &#8594 A', title: 'Name'},
    phone:           { asc: '1 &#8594 9', desc: '9 &#8594 1', title: 'Phone' },
    region:          { asc: 'A &#8594 Z', desc: 'Z &#8594 A', title: 'Region' },
    date_joined:     { asc: '1 &#8594 9', desc: '9 &#8594 1', title: 'Date Joined' },
    times_played:    { asc: '1 &#8594 9', desc: '9 &#8594 1', title: 'Times Played' },
    dates_played:    { asc: '1 &#8594 9', desc: '9 &#8594 1', title: 'Dates Played' },
    facility: { asc: '1 &#8594 9', desc: '9 &#8594 1', title: 'Facility Played' },
    cancelled_games: { asc: '1 &#8594 9', desc: '9 &#8594 1', title: 'Cancelled Games' },
    gender:          { asc: 'A &#8594 Z', desc: 'Z &#8594 A', title: 'Gender' },
    banned:          { asc: '&#9635 &#8594 &#9634', desc: '&#9634 &#8594 &#9635', title: 'Banned' },
    opted_out:       { asc: 'A &#8594 Z', desc: 'Z &#8594 A', title: 'Opted out' },
    captain:         { asc: '&#9635 &#8594 &#9634', desc: '&#9634 &#8594 &#9635', title: 'Captain' }
   }
  const allSortings = Object.fromEntries(Object.entries(initialSortings).filter( el => !sortingsToExclude.includes(el[0])))
  const [sortingList, setSorting] = useState(initialSorting.length > 0 ? initialSorting: [{column: 'name', direction: 'asc'}] )
  const [freeSortting, setFreeSorting] = useState(Object.keys(allSortings).filter( el => !sortingList.map(el => el.column).includes(el)))

  const addNewSorting = ()=> {
    setSorting(sortingList.concat({column: freeSortting[0], direction: 'asc'}))
    setFreeSorting(freeSortting.slice(1))
  }

  const updateSortingColumn = (selection, previous)=> {
    const updatedSortList = sortingList.filter( el => el.column != selection.target.value ).map( el =>
        el.column == previous ? {column: selection.target.value, direction: 'asc'} : el
    )
    setSorting(updatedSortList)
    setFreeSorting(Object.keys(allSortings).filter(el => freeSortting.concat(previous).includes(el)))
  }

  const updateSortingDirection = (selection, sortColumn)=> {
    setSorting(sortingList.map( el => el.column == sortColumn ? {column: el.column, direction: selection.target.value} : el ))
  }

  const removeSorting = (sortColumn)=> {
    setSorting(sortingList.filter( el => el.column != sortColumn ))
    setFreeSorting(Object.keys(allSortings).filter(el => freeSortting.concat(sortColumn).includes(el)))
  }

  const onSortSubmit = ()=> {
    onSubmit(sortingList)
  }

  return <Modal container={document.body} show={true} onHide={onClose} className='sorting-modal'>
    <Modal.Header closeButton>
      <Modal.Title>Sort by</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
        <div className='sorting-list'>
          <table className='table text-center table-transference'>
            <tbody>
            { sortingList && sortingList.map((sort) =>
              <tr key={sort.column}>
                <td>
                  <div className='col-sm-6 text-center'>
                    <select name='sorting-type' defaultValue={sort.column} onChange={e=> updateSortingColumn(e,sort.column)}>
                      { Object.keys(allSortings).map((o, i) => <option key={i+o} value={o}>{allSortings[o].title}</option>) }
                    </select>
                  </div>
                  <div className='col-sm-4 text-center'>
                    <select name='direction' defaultValue={sort.direction} onChange={e => updateSortingDirection(e,sort.column)}>
                      { ['asc','desc'].map((o, i) => <option key={i} value={o}>{
                        new DOMParser().parseFromString(allSortings[sort.column][o], 'text/html').body.textContent  }</option>) }
                    </select>
                  </div>
                  <div className='col-sm-1 text-center'>
                    <span className='fa fa-trash' onClick={() => removeSorting(sort.column)}></span>
                  </div>
                </td>
              </tr>
              )
            }
            {freeSortting.length > 1 &&
              <tr key='add_sort'>
                <td>
                  <div className='col-sm-6 text-center'>
                    <a onClick={() => addNewSorting()} className='btn'>&#43; Add another sort</a>
                  </div>
                </td>
              </tr>}
            </tbody>
          </table>
        </div>
        <div>
          <div className='col-sm-6 text-center'>
            <button className='btn btn-default' onClick={onClose}>
              Cancel
            </button>
          </div>
          <div className='col-sm-5 text-center'>
            <button className='btn btn-primary' onClick={onSortSubmit}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </Modal.Body>
  </Modal>
}

export default SortingForm
